import { PLAN_COLUMNS, PLAN_FREQUENCY_ROWS, PLAN_LIMIT_ROWS, type PlanTableRow } from "../../lib/planCatalog";

type PlanTableProps = {
  rows: PlanTableRow[];
  ariaLabel: string;
};

export function PlanTable({ rows, ariaLabel }: PlanTableProps) {
  return (
    <div className="legal-plan-table-scroll overflow-x-auto rounded-2xl border border-[#EADBC8]">
      <table aria-label={ariaLabel} className="w-full min-w-[38rem] border-collapse bg-white text-left text-xs leading-6 md:min-w-0">
        <thead className="bg-[#FDF8F5] text-[#5D4D46]">
          <tr>
            <th scope="col" className="px-3 py-3 font-bold md:w-[22%]">
              機能
            </th>
            {PLAN_COLUMNS.map((column) => (
              <th key={column.key} scope="col" className="px-3 py-3 font-bold">
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-[#EADBC8]">
          {rows.map((row) => (
            <tr key={row.feature}>
              <th scope="row" className="break-keep px-3 py-3 font-bold text-[#5D4D46]">
                {row.feature}
              </th>
              {PLAN_COLUMNS.map((column) => (
                <td key={column.key} className="break-keep px-3 py-3 align-top">
                  {row.values[column.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function PlanLimitTable() {
  return <PlanTable rows={PLAN_LIMIT_ROWS} ariaLabel="プラン別利用上限" />;
}

export function PlanFrequencyTable() {
  return <PlanTable rows={PLAN_FREQUENCY_ROWS} ariaLabel="プラン別定期配信頻度" />;
}
